import { createLogger } from './logger';

const log = createLogger('media');

export async function acquireLocalMedia() {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: { width: { ideal: 1280 }, height: { ideal: 720 } },
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
    },
  });
  log('acquired', {
    tracks: stream.getTracks().map((t) => ({ kind: t.kind, label: t.label, enabled: t.enabled })),
  });
  return stream;
}

export function stopStream(stream) {
  if (!stream) return;
  stream.getTracks().forEach((t) => {
    t.stop();
    log('track-stopped', { kind: t.kind });
  });
}
